/**
 * Notifications carry server-issued `link` values. We only navigate when
 * the link is a same-origin relative path beginning with `/`. This rejects
 * absolute URLs (`https://...`), protocol-relative URLs (`//evil.com`),
 * scheme-relative payloads, backslash tricks (`/\evil.com`, which browsers
 * normalize to `//evil.com`), and anything that doesn't start with a slash.
 *
 * Single source of truth for both the notifications page and the global
 * notification bell so the two surfaces cannot drift apart.
 */
export function isSafeRelativeLink(link: string): boolean {
  if (typeof link !== 'string' || link.length === 0) return false;
  if (!link.startsWith('/')) return false;
  // Reject protocol-relative `//host` paths.
  if (link.startsWith('//')) return false;
  // Reject backslash variants; browsers normalize `\` to `/`, so `/\evil.com`
  // is treated as protocol-relative `//evil.com`.
  if (link.includes('\\')) return false;
  return true;
}
